import { createUseStyles } from 'react-jss'
import { colors } from '../../variables.style'

export const style = {
  inputContainer: {
    border: `1px solid ${colors.borderGray}`,
    borderRadius: 25,
    padding: '4px 5px 4px 8px',
    backgroundColor: '#FFF',
    '&:before': {
      color: colors.borderGray,
      verticalAlign: 'middle'
    }
  },
  input: {
    width: 80,
    border: 'none',
    outline: 'none',
    marginLeft: 5,
    verticalAlign: 'middle',
    fontSize: 15,
    '&::placeholder': {
      color: colors.borderGray
    },
    '&:focus + .form-element-border': {
      visibility: 'visible',
      opacity: 1,
      transform: 'scale(1)',
      borderRadius: 25,
      left: 0
    }
  },
  focused: {
    borderColor: 'transparent'
  }
}

export const useStyles = createUseStyles(style)
